import { brl } from "@/lib/format";

const digits = (phone) => {
  const d = (phone || "").replace(/\D/g, "");
  return d.startsWith("55") ? d : `55${d}`;
};

const trackUrl = (order) => `${window.location.origin}/pedido/${order.id}`;

const MESSAGES = {
  aguardando_comprovante: (o) => `Oi ${o.customer_name}! Recebemos seu pedido #${o.number} no valor de ${brl(o.total)}.\nPara validar sua compra, por favor envie o comprovante do Pix aqui neste WhatsApp.${o.pix_key ? `\nChave Pix: ${o.pix_key}` : ""}\nAssim que o comprovante chegar já começamos a separar seu pedido. 🍻`,
  preparando: (o) => `Oi ${o.customer_name}! Seu pedido #${o.number} foi confirmado e já está sendo separado. 🍻`,
  saiu: (o) => o.fulfillment === "entrega"
    ? `Oi ${o.customer_name}! Seu pedido #${o.number} saiu para entrega e chega logo no endereço ${o.address}. Total: ${brl(o.total)}.`
    : `Oi ${o.customer_name}! Seu pedido #${o.number} está pronto para retirada. Total: ${brl(o.total)}.`,
  concluido: (o) => `Oi ${o.customer_name}! Pedido #${o.number} ${o.fulfillment === "entrega" ? "entregue" : "retirado"}. Valeu pela preferência! 🍻`,
  cancelado: (o) => `Oi ${o.customer_name}, infelizmente precisamos cancelar seu pedido #${o.number}. Qualquer dúvida é só chamar.`,
};

export const canNotify = (status) => !!MESSAGES[status];

export const whatsappLink = (order, status = order.status) => {
  const build = MESSAGES[status];
  if (!build) return null;
  const text = `${build(order)}\n\nAcompanhe: ${trackUrl(order)}\n— Depósito do Primo`;
  return `https://wa.me/${digits(order.phone)}?text=${encodeURIComponent(text)}`;
};

export const notifyWhatsapp = (order, status = order.status) => {
  const url = whatsappLink(order, status);
  if (url) window.open(url, "_blank", "noopener");
};
